import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigProvider } from "antd";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import PropertyDetail from "./pages/PropertyDetail";
import TransactionHistory from "./pages/TransactionHistory";
import Test from "./pages/Test";
import BottomNav from "./components/BottomNav";

// ✅ Set base URL dan token dari localStorage
axios.defaults.baseURL = "https://prodmejatika.bljambi.com";
const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

function App() {
  const [loading, setLoading] = useState(true);

  // Fungsi untuk sinkronisasi token (Penting untuk Login Pi SDK)
  // Fungsi ini tetap ada agar bisa dipanggil jika dibutuhkan di masa depan/komponen lain
  const syncTokenFromBackend = async (piPayload) => {
    try {
      const res = await axios.post("/api/auth/sdk-login", piPayload);

      if (res.data?.token) {
        localStorage.setItem("token", res.data.token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${res.data.token}`;

        await Swal.fire({
          icon: "success",
          title: "Login berhasil",
          text: "Token backend tersimpan.",
        });

        window.location.reload(); 
      } else {
        throw new Error("Token tidak ditemukan di response.");
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Gagal login",
        text: err.response?.data?.message || "Gagal sinkronisasi token.",
      });
    }
  };

  const fetchAccountData = async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      // Memastikan session masih aktif di server
      await Promise.all([
        axios.get("/api/auth/profile"),
        axios.get("/api/transactions"),
      ]);
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("usernamePi");
        // Tidak memunculkan Swal di sini agar tidak mengganggu user saat baru buka app
      } else {
        console.error("Gagal ambil data akun:", err);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccountData();
    
    // Mengekspos fungsi sync ke window agar bisa dipanggil dari index.html atau Pi SDK jika perlu
    window.syncTokenFromBackend = syncTokenFromBackend;
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-medium">⏳ Memuat data akun...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-lg mx-auto border-x h-screen overflow-y-auto pb-24 bg-white">
      <ConfigProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/detail/:uuid" element={<PropertyDetail />} />
            <Route path="/test" element={<Test />} />
            <Route path="/transactions" element={<TransactionHistory />} />
          </Routes>
          <BottomNav />
        </Router>
      </ConfigProvider>
    </div>
  );
}

export default App;
